import { Avatar } from 'antd'

import { LucideIconByName } from 'src/components'

import { readAppLucideIcon } from '../utils/appIcon'

import {
  APP_ICON_BORDER_RADIUS,
  APP_ICON_GLYPH_RATIO,
  AppTypeIcon
} from './AppTypeIcon'

type AppIconProps = {
  /** Instance type code, used when the app carries no icon of its own. */
  type: string | null | undefined
  /** Uploaded launcher image (`Application.icon.file`). Wins over the glyph. */
  photoUrl?: string | null
  /** Raw `Application.settings`; a stored Lucide glyph is read out of it. */
  settings?: Record<string, unknown> | null
  size?: number
}

export const AppIcon = ({
  type,
  photoUrl,
  settings,
  size = 40
}: AppIconProps) => {
  if (photoUrl) {
    return (
      <Avatar
        size={size}
        shape="square"
        src={photoUrl}
        style={{ borderRadius: APP_ICON_BORDER_RADIUS, minWidth: size }}
      />
    )
  }

  const lucide = readAppLucideIcon(settings)

  if (!lucide) {
    return <AppTypeIcon type={type} size={size} />
  }

  return (
    <Avatar
      size={size}
      shape="square"
      icon={
        <LucideIconByName
          name={lucide.name}
          size={Math.round(size * APP_ICON_GLYPH_RATIO)}
        />
      }
      style={{
        backgroundColor: lucide.color,
        borderRadius: APP_ICON_BORDER_RADIUS,
        minWidth: size
      }}
    />
  )
}
